import { ref } from "vue";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import jb from "@frontend/effuse";

let tokenPromise: Promise<string> | undefined;
const tokenVersion = ref(0);

export const getAppTokenVersion = (): number => tokenVersion.value;

export function invalidateAppToken(expectedVersion?: number): boolean {
  if (expectedVersion !== undefined && expectedVersion !== tokenVersion.value) {
    return false;
  }
  tokenPromise = undefined;
  tokenVersion.value++;
  return true;
}

// 一次身份同步期间，profile 和业务请求共用同一个原生 token。
export function getAppToken(refresh = false): Promise<string> {
  if (tokenPromise && !refresh) return tokenPromise;
  tokenVersion.value++;

  const pending = new Promise<string>((resolve, reject) => {
    const timer = setTimeout(() => fail(), 5000);
    const fail = (value?: unknown) => {
      clearTimeout(timer);
      // effuse 将原生空字符串回调转发到 fail；只有此值明确表示未登录。
      if (value === "") {
        resolve("");
        return;
      }
      reject(new Error("无法获取 App 登录状态，请重试"));
    };
    const success = (token: unknown) => {
      if (typeof token !== "string") {
        fail();
        return;
      }
      clearTimeout(timer);
      // 空字符串表示明确未登录，公开接口仍可匿名访问。
      resolve(token.trim());
    };

    try {
      if (jb.isApp()) {
        jb.token("", { success, fail });
      } else {
        // 旧临界容器只提供 UA token；新容器失败时不能退回旧 UA。
        success(jb.tokenSync(""));
      }
    } catch {
      fail();
    }
  });

  tokenPromise = pending;
  pending.catch(() => {
    if (tokenPromise === pending) tokenPromise = undefined;
  });
  return pending;
}
